export const aftercareEntries = [
  {
    id: "microneedling",
    title: "Microneedling",
    items: [
      "The steps taken after Microneedling are super important and must be taken seriously to ensure your skin heals as it should.",
      "DAY OF TREATMENT",
      "Do not wash your face, apply any products or makeup.",
      "Do not touch your face unless your hands are clean and sanitised",
      "Avoid exercising and sweating for 12 hours",
      "Avoid swimming, sauna or similar spa environments for 3 days",
      "Sleep on a clean fresh pillowcase, preferably silk",
      "12+ HOURS AFTER TREATMENT",
      "Once 12 hours has passed you can then cleanse your face as normal and apply your usual products minus the below…",
      "Products to avoid for 3-5 days; Retinals, Glycolic Acid, Salicylic Acid, Scrubs, Exfoliators.",
      "Makeup is still to be avoided until 24 hours has passed. When you apply your makeup for the first time after Microneedling, ensure your brushes and tools are clean and sanitised",
      "Do not have any other treatments for 2 weeks post Microneedling and 4 weeks before another session.",
    ],
  },
  {
    id: "chemical-peels",
    title: "Chemical Peels",
    items: [
      "The steps taken after a Chemical Peel are super important and must be taken seriously to ensure your skin heals as it should.",
      "DAY OF TREATMENT",
      "Do not wash your face, apply any products or makeup.",
      "Do not touch your face unless your hands are clean and sanitised",
      "Avoid exercising and sweating for 12 hours",
      "Avoid swimming, sauna or similar spa environments for 3 days",
      "Sleep on a clean fresh pillowcase, preferably silk",
      "12+ HOURS AFTER TREATMENT",
      "Once 12 hours has passed you can then cleanse your face as normal and apply your usual products minus the below…",
      "Products to avoid for 3-5 days; Glycolic Acid, Salicylic Acid, Scrubs, Exfoliators.",
      "Makeup is still to be avoided until 24 hours has passed. When you apply your makeup for the first time after a chemical peel, ensure your brushes and tools are clean and sanitised",
      "Do not have any other treatments for 2 weeks post Chemical Peel.",
    ],
  },
  {
    id: "dermaplaning",
    title: "Dermaplaning",
    items: [
      "Do not wash your face, apply any products or makeup for 12 hours",
      "Once 12 hours has passed you can then cleanse your face as normal and apply your usual products minus the below…",
      "Products to avoid for 3-5 days; Glycolic Acid, Salicylic Acid, Scrubs, Exfoliators Etc.",
      "Makeup is still to be avoided until 24 hours has passed. When you apply your makeup for the first time after Dermaplaning ensure your brushes and tools are clean and sanitised",
      "Do not touch your face unless your hands are clean and sanitised",
      "Avoid exercising and sweating for 12 hours",
      "Avoid swimming, sauna or similar spa environments for 24 hours",
      "Sleep on a clean fresh pillowcase - preferably silk.",
    ],
  },
];
